import { useParams } from 'react-router-dom';
import RestfulWrapper from "../../../components/RestfulWrapper/RestfulWrapper";
import { useStoreActions } from "../../../store/store-context";
import AllSetPageRoutedWithAnimations from "./AllSetPageWithAnimations";
import { jsx as _jsx } from "react/jsx-runtime";
function AllSetPageQueryWrapper(props) {
  const {
    api
  } = useStoreActions();
  const {
    relationshipId: relationshipIdParam
  } = useParams();
  const relationshipId = relationshipIdParam || props.relationshipId;
  async function fetchData() {
    if (!relationshipId) throw new Error('No relationshipId provided');
    const [relationship] = await Promise.all([api.relationship.get(relationshipId)]);
    return {
      relationship
    };
  }
  return /*#__PURE__*/_jsx(RestfulWrapper, {
    fetch: fetchData,
    renderChild: _ref => {
      let {
        data
      } = _ref;
      return /*#__PURE__*/_jsx(AllSetPageRoutedWithAnimations, {
        relationship: data.relationship
      });
    }
  });
}
export default AllSetPageQueryWrapper;